<template>
  <div id="app">
    <online-status/>

    <transition name="slide">
      <router-view class="fast" />
    </transition>

    <portal-target name="modal"/>
    <portal-target name="image-cropping"/>

    <notifications/>
  </div>
</template>

<script>
import store from '@/store';
import Notifications from './components/Notifications.vue';
import OnlineStatus from '@/components/OnlineStatus.vue';
import AuthMixin from '@/mixins/auth_mixin';

export default {
  name: 'app',

  components: { OnlineStatus, Notifications },

  mixins: [AuthMixin],

  data() {
    return {
      state: store.state,
    };
  },

  async created() {
    this.$bus.$on('reload-state', this.setState);
    this.$bus.$on('unauthenticated', () => {
      if (!this.$router.currentRoute.meta.noLoginRequired) {
        this.$router.push({ name: 'login' });
      }
    });

    this.setState();
  },
};
</script>

<style lang="scss">
@import "scss/main.scss";

.disconnected_message {
  position: fixed;
  background-color: #8a0006;
  color: white;
  z-index: 6;
}

.no_height {
  height: 0;
}
</style>
